import { render } from "./Logistics.vue?vue&type=template&id=f637e790&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=f637e790&lang=scss"
import "./Logistics.vue?vue&type=style&index=1&id=f637e790&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f637e790"]])

export default __exports__